// Egresos del gestor (7-oct-2026).
export const managementExpenses = {
  categories: {
    cleaning: "Sprzątanie",
    laundry: "Pralnia",
    maintenance: "Konserwacja i naprawy",
    supplies: "Wyposażenie i materiały eksploatacyjne",
    utilities: "Media",
    staff: "Personel",
    software: "Oprogramowanie i narzędzia",
    marketing: "Reklama",
    taxes: "Podatki i opłaty",
    other: "Inne",
  },

  restricted: "Wydatki zarządcy widzi tylko konto główne: Twój dostęp jest ograniczony do niektórych obiektów.",

  summary: {
    aria: "Podsumowanie wydatków w okresie. Wybierz kwotę, aby przefiltrować tabelę.",
    total: "Wydatki łącznie",
    count: "{n} wydatek | {n} wydatki | {n} wydatków",
    charged: "Przeniesione na właścicieli",
    chargedHint: "Potrącane w ich rozliczeniach",
    own: "Własne wydatki",
    ownHint: "Pomniejszają Twój zysk",
  },

  toolbar: {
    search: "Szukaj",
    searchPlaceholder: "Opis lub dostawca",
    clearSearch: "Wyczyść wyszukiwanie",
    category: "Kategoria",
    allCategories: "Wszystkie",
    listing: "Obiekt",
    allListings: "Wszystkie",
    type: "Rodzaj",
    allTypes: "Wszystkie",
    charged: "Przeniesione na właściciela",
    own: "Własne",
    create: "Nowy wydatek",
  },

  table: {
    date: "Data",
    category: "Kategoria",
    concept: "Opis",
    listing: "Obiekt",
    chargedTo: "Na koszt",
    amount: "Kwota",
    receipt: "Paragon",
    actions: "Akcje",
    general: "Ogólny",
    management: "Zarządca",
    ownerMissing: "Brak przypisanego właściciela",
    notCharged: "Obiekt nie jest już zarządzany: tym wydatkiem nikt nie zostaje obciążony",
    vat: "VAT {pct}%",
    download: "Pobierz paragon",
    edit: "Edytuj",
    remove: "Usuń",
  },

  empty: {
    title: "Brak wydatków w tym okresie",
    text: "Zapisuj, za co płacisz (sprzątanie, pralnia, naprawy, oprogramowanie…), i zdecyduj, czy obciążasz nim właściciela, czy to wydatek zarządcy.",
    create: "Dodaj wydatek",
    filteredTitle: "Żaden wydatek nie pasuje do filtrów",
    filteredText: "Spróbuj innego wyszukiwania albo usuń filtry, aby zobaczyć wszystkie wydatki z okresu.",
    clear: "Usuń filtry",
  },

  load: {
    error: "Nie udało się wczytać wydatków.",
    retry: "Spróbuj ponownie",
  },

  remove: {
    title: "Usunąć ten wydatek?",
    message: "„{concept}” ({amount}) przestanie się liczyć w analityce i w rozliczeniach właścicieli.",
    confirm: "Usuń",
    done: "Wydatek usunięty",
    error: "Nie udało się usunąć wydatku. Spróbuj ponownie.",
  },

  receiptError: "Nie udało się pobrać paragonu.",

  drawer: {
    newTitle: "Nowy wydatek",
    editTitle: "Edytuj wydatek",
    newSubtitle: "To, co płacisz za zarządzanie: na koszt właściciela albo Twojej firmy.",
    editSubtitle: "Zmiany od razu widać w analityce i w rozliczeniach.",
    close: "Zamknij",
    sections: {
      expense: "Wydatek",
      listing: "Obiekt i właściciel",
      notes: "Notatki",
      receipt: "Paragon lub faktura",
    },
    fields: {
      concept: "Opis",
      conceptPlaceholder: "Np. Sprzątanie po wyjeździe",
      category: "Kategoria",
      date: "Data",
      supplier: "Dostawca",
      supplierPlaceholder: "Np. Pralnia Słoneczna",
      amount: "Kwota",
      vat: "VAT",
      vatHint: "Tylko informacyjnie: kwota to tyle, ile zapłaciłeś, z VAT.",
      listing: "Obiekt",
      listingGeneral: "Ogólny wydatek zarządcy (bez obiektu)",
      unit: "Jednostka",
      unitAll: "Cały obiekt",
      notesPlaceholder: "Dowolny szczegół, który chcesz zapamiętać",
    },
    charge: {
      label: "Obciąż właściciela",
      general: "Wydatek ogólny zawsze należy do zarządcy. Wybierz obiekt, aby obciążyć nim jego właściciela.",
      loading: "Sprawdzanie obiektu…",
      error: "Nie udało się sprawdzić, czy ten obiekt jest zarządzany.",
      retry: "Spróbuj ponownie",
      notManaged: "Ten obiekt nie jest oznaczony jako zarządzany: wydatek liczy się jako Twój własny.",
      notManagedMarked: "Obiekt nie jest już zarządzany: nikt nie zostaje obciążony. Wyłącz tę opcję, aby zostawić go jako wydatek własny.",
      own: "Jeśli nie obciążysz właściciela, liczy się jako wydatek własny zarządcy.",
      owner: "Zostanie potrącony w rozliczeniu: {owner}.",
      noOwner: "Obiekt nie ma jeszcze przypisanego właściciela: wydatek zostanie potrącony w rozliczeniu osoby, którą przypiszesz.",
    },
    receipt: {
      drop: "Przeciągnij tutaj zdjęcie lub PDF",
      pick: "albo wybierz plik",
      formats: "JPG, PNG, WEBP, HEIC lub PDF · maks. 10 MB",
      current: "Zapisany paragon",
      download: "Pobierz",
      change: "Zmień",
      remove: "Usuń",
      undo: "Cofnij",
      willRemove: "Paragon zostanie usunięty po zapisaniu.",
      willReplace: "zastąpi zapisany",
      tooBig: "Plik ma więcej niż 10 MB.",
      badType: "Nieobsługiwany format: dodaj zdjęcie (JPG, PNG, WEBP lub HEIC) albo PDF.",
    },
    errors: {
      required: "To pole jest wymagane.",
      category: "Wybierz kategorię.",
      amount: "Wpisz kwotę większą niż 0.",
      vat: "Wpisz wartość procentową od 0 do 100.",
      review: "Sprawdź zaznaczone pola.",
      generic: "Nie udało się zapisać wydatku. Spróbuj ponownie.",
    },
    discard: {
      title: "Odrzucić zmiany?",
      message: "To, co wpisałeś w tym wydatku, zostanie utracone.",
      confirm: "Odrzuć",
      cancel: "Edytuj dalej",
    },
    cancel: "Anuluj",
    save: "Zapisz wydatek",
    saveChanges: "Zapisz zmiany",
    saving: "Zapisywanie…",
    created: "Wydatek zapisany",
    updated: "Zmiany zapisane",
    outOfPeriod: "Zapisano. Jego data ({date}) wykracza poza wyświetlany okres.",
  },
};
